import { render, staticRenderFns } from "./RpmShowSkeleton.vue?vue&type=template&id=1bd5cc5c&scoped=true&"
import script from "./RpmShowSkeleton.vue?vue&type=script&lang=js&"
export * from "./RpmShowSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5cc5c",
  null
  
)

export default component.exports